import { Component, Input } from '@angular/core';

@Component({
    selector: 'pim-value-display',
    templateUrl: './value-display.component.html',
    styleUrls: ['./value-display.component.sass'],
    standalone: false
})
export class ValueDisplayComponent {
	@Input()
	title: string | null = '';

	@Input()
	value: string | null = '';

	@Input()
	wrapperClass: string = 'pb-3';
}
